import React from "react"
//import I18n from "i18n-js/index.js.erb"

class ReservationSegmentSelect extends React.Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.initSelect2();
  }

  initSelect2() {
    var self = this;

    if (this.refs.reservation_segment) {
      $(this.refs.reservation_segment).select2({
        ajax: {
          url: '/admin/reservation_segments_remote',
          dataType: 'json',
          delay: 250,
          data: (params) => {
            return {
              q: params.term,
              page: params.page,
              results_per_page: 40,
           };
         },
         processResults: function(data, params) {
           params.page = params.page || 1;
           return {
             results: data.reservation_segments,
             pagination: {
               more: (params.page * 40) < data.total_coun
             }
           };
         },
         cache: true
       },
       allowClear: false,
       escapeMarkup: function(markup) {
         return markup;
       },
       placeholder: I18n.t('select_ellipsis'),
       templateResult: function (reservation_segment) {
         return self.renderReservationSegmentDetails(reservation_segment);
       },
       templateSelection: function (reservation_segment) {
         if (reservation_segment && reservation_segment.id != null && reservation_segment.id != '') {
           self.props.onChange(reservation_segment)
         }
         return self.renderReservationSegmentDetails(reservation_segment);
       }
     }).on('select2:unselect', function() {
       self.props.onChange(null);
     }).on('select2:select', function(selection) {
       self.props.onChange(selection.params.data);
     });
    }
  }

  render() {
    return(
      <select className="form-control" ref="reservation_segment" style={{width: '100%', minHeight: 33}}>
        {this.props.reservation_segment ? <option value={this.props.reservation_segment.id}>{this.renderReservationSegmentDetails(this.props.reservation_segment)}</option> : null}
      </select>
    )
  }

  renderReservationSegmentDetails(reservation_segment) {
    return reservation_segment.text
  }

};

export default ReservationSegmentSelect